import { Controller } from "@hotwired/stimulus"

// Tiny controller for one comment in the study group discussion — toggles the
// inline reply form open and closed.
export default class extends Controller {
  static targets = ["replyForm"]

  toggleReply(event) {
    event.preventDefault()
    if (!this.hasReplyFormTarget) return
    this.replyFormTarget.classList.toggle("hidden")
    if (!this.replyFormTarget.classList.contains("hidden")) {
      const textarea = this.replyFormTarget.querySelector("textarea")
      textarea?.focus()
    }
  }
}
